import * as React from 'react';

import NoEntities from '../../shared/NoEntities';

const NoScenes: React.FunctionComponent = () => {
  return <NoEntities>作成したシーンがありません</NoEntities>;
};

export default React.memo(NoScenes);
